/* OXXRING v2 material guide: need selector, temperature chart, property matrix, A-vs-B compare.
   The pure part (pairModel, renderCompare) is also run by build-materials.mjs to server-render the default pair. */
(function (g) {
  'use strict';

  var LEVEL = ['', 'Poor', 'Fair', 'Good', 'Excellent'];
  var MINUS = '−';
  var SRC = 'material-guide';

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function toF(c) { return Math.round(c * 9 / 5 + 32); }
  function toC(f) { return (f - 32) * 5 / 9; }
  function sn(n) { return n < 0 ? MINUS + Math.abs(n) : String(n); }
  function tRange(t, unit) { return unit === 'F' ? sn(toF(t.min)) + ' to ' + sn(toF(t.max)) + ' °F' : sn(t.min) + ' to ' + sn(t.max) + ' °C'; }
  function joinOr(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' or ' + a[a.length - 1]; }
  function thousands(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function famMap(D) {
    if (!D._map) { D._map = {}; D.fam.forEach(function (f) { D._map[f.k] = f; }); }
    return D._map;
  }
  function pairNote(D, a, b) { return D.notes[a + '-' + b] || D.notes[b + '-' + a] || ''; }
  function costText(n) { return new Array(n + 1).join('$'); }

  /* ---------- links ---------- */
  function shopUrl(U, f) { return U.col + '/' + f.collection; }
  function finderUrl(U, f, extra) { return U.finder + '&units=mm&material=' + f.finder + (extra || '') + '&source=' + SRC; }
  function rfqUrl(U, mode, f, context) {
    return U.rfq + '?source=' + SRC + '&request_mode=' + mode + (f ? '&material=' + encodeURIComponent(f.code) : '') + (context ? '&context=' + encodeURIComponent(context.slice(0, 1500)) : '');
  }
  function chemUrl(U, f) { return U.chem + '?source=' + SRC + (f ? '&material=' + encodeURIComponent(f.code) : ''); }

  /* ---------- compare model (pure) ---------- */
  function pairModel(D, ka, kb) {
    var F = famMap(D), A = F[ka], B = F[kb];
    if (!A || !B || ka === kb) return null;
    // Ratings are published only after engineering review; without them the compare shows plates and guidance only.
    var rated = !!(D.props && A.r && B.r);
    var rows = !rated ? [] : D.props.map(function (p, i) {
      var a = A.r[p.k], b = B.r[p.k];
      return { k: p.k, label: p.label, phrase: p.phrase, i: i, a: a, b: b, win: a > b ? 'a' : (b > a ? 'b' : '') };
    });
    function side(X, Y, me) {
      if (!rated) return { f: X, wins: [], when: '', weak: [] };
      var wins = rows.filter(function (r) { return r.win === me; })
        .map(function (r) { return { k: r.k, label: r.label, phrase: r.phrase, d: Math.abs(r.a - r.b), i: r.i }; });
      if (X.cost != null && Y.cost != null && X.cost < Y.cost) wins.unshift({ k: 'cost', label: 'Lower cost', phrase: D.costPhrase, d: Y.cost - X.cost, i: -1 });
      var top = wins.slice().sort(function (x, y) { return (y.d - x.d) || (x.i - y.i); }).slice(0, 3);
      var weak = rows.filter(function (r) { return (me === 'a' ? r.a : r.b) === 1; }).map(function (r) { return r.label; });
      var when = top.length
        ? 'Choose ' + X.label + ' when ' + joinOr(top.map(function (w) { return w.phrase; })) + '.'
        : X.label + ' has no screened advantage over ' + Y.label + '. Choose it only when a compound approval or the fit calls for it.';
      return { f: X, wins: wins, when: when, weak: weak };
    }
    return { key: ka + '-' + kb, a: side(A, B, 'a'), b: side(B, A, 'b'), rows: rows, note: pairNote(D, ka, kb) };
  }

  /* ---------- compare renderer (HTML string; all data is build-time and escaped) ---------- */
  function plate(label, value, sub) {
    return '<div><dt>' + esc(label) + '</dt><dd>' + value + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</dd></div>';
  }
  function famPlates(f) {
    var t = f.t ? esc(tRange(f.t, 'C')) : '—';
    var h = f.hard.sold ? f.hard.sold[0] + '–' + f.hard.sold[f.hard.sold.length - 1] + ' ShA' : (f.hard.reviewed ? f.hard.reviewed[0] + '–' + f.hard.reviewed[1] + ' ShA' : '—');
    return '<dl class="ic-materials-plates">' +
      plate('Typical temp.', t, f.t ? tRange(f.t, 'F') : 'Confirmed per compound') +
      plate('Hardness', h, f.hard.sold ? 'Listed grades' : 'Grades reviewed · on request') +
      plate('Specific gravity', f.sg ? f.sg.toFixed(2) : '—', f.sg ? '' : 'Not enough records') +
      plate('Tensile', f.ts ? f.ts.mpa + ' MPa' : '—', f.ts ? thousands(f.ts.psi) + ' psi' : 'Not enough records') +
      plate('Elongation', f.el ? f.el + ' %' : '—', f.el ? 'At break' : 'Not enough records') +
      (f.cost == null ? '' : plate('Relative cost', '<span class="ic-materials-cost" aria-label="' + f.cost + ' of 5">' + costText(f.cost) + '<span aria-hidden="true">' + costText(5 - f.cost) + '</span></span>', '')) +
      '</dl>';
  }
  function famActions(U, f) {
    if (f.sold) {
      return '<a class="ic-btn ic-btn--dark ic-btn--sm" href="' + esc(shopUrl(U, f)) + '">Shop ' + esc(f.label) + '</a>' +
        '<a class="ic-btn ic-btn--ghost ic-btn--sm" href="' + esc(finderUrl(U, f)) + '">Find a size in ' + esc(f.label) + '</a>';
    }
    return '<a class="ic-btn ic-btn--dark ic-btn--sm" href="' + esc(rfqUrl(U, 'CUSTOM', f, 'Material guide: ' + f.label + ' O-rings requested')) + '">Request ' + esc(f.label) + '</a>';
  }
  function famHead(f, side) {
    return '<header class="ic-materials-cmp__head"><span class="ic-materials-key ic-materials-key--' + side + '" aria-hidden="true"></span>' +
      '<div><h3 class="ic-h3">' + esc(f.label) + ' <small>' + esc(f.label === f.name ? f.code : f.name) + '</small></h3>' +
      '<p class="ic-small">' + esc(f.what) + '</p></div>' +
      (f.sold ? '<span class="ic-materials-badge">In catalog</span>' : '<span class="ic-route ic-route--CUSTOM">Quote only</span>') + '</header>';
  }
  function renderCompare(D, m, U) {
    var A = m.a.f, B = m.b.f;
    var h = '<div class="ic-materials-cmp__grid">';
    [['a', A], ['b', B]].forEach(function (s) {
      h += '<article class="ic-materials-cmp__fam ic-materials-cmp__fam--' + s[0] + '">' + famHead(s[1], s[0]) + famPlates(s[1]) +
        '<div class="ic-materials-actions">' + famActions(U, s[1]) + '</div></article>';
    });
    h += '</div>';

    if (!m.rows.length) return h + guidance(m, A, B, U);

    h += '<div class="ic-materials-duel" role="table" aria-label="Screening ratings, ' + esc(A.label) + ' versus ' + esc(B.label) + '">' +
      '<div class="ic-materials-duel__row ic-materials-duel__row--head" role="row">' +
      '<span class="ic-materials-duel__a" role="columnheader"><i class="ic-materials-key ic-materials-key--a" aria-hidden="true"></i>' + esc(A.label) + '</span>' +
      '<span class="ic-materials-duel__p" role="columnheader">Property</span>' +
      '<span class="ic-materials-duel__b" role="columnheader">' + esc(B.label) + '<i class="ic-materials-key ic-materials-key--b" aria-hidden="true"></i></span></div>';
    m.rows.forEach(function (r) {
      var cls = r.win ? ' is-win-' + r.win : ' is-tie';
      h += '<div class="ic-materials-duel__row' + cls + '" role="row">' +
        '<span class="ic-materials-duel__a" role="cell"><em>' + LEVEL[r.a] + '</em><span class="ic-materials-duel__bar" style="--v:' + r.a + '" aria-hidden="true"></span></span>' +
        '<span class="ic-materials-duel__p" role="rowheader">' + esc(r.label) + (r.win ? '<small>' + esc((r.win === 'a' ? A : B).label) + ' ahead</small>' : '<small>Even</small>') + '</span>' +
        '<span class="ic-materials-duel__b" role="cell"><span class="ic-materials-duel__bar" style="--v:' + r.b + '" aria-hidden="true"></span><em>' + LEVEL[r.b] + '</em></span></div>';
    });
    h += '</div>';

    h += '<div class="ic-materials-cmp__verdict">';
    [['a', m.a], ['b', m.b]].forEach(function (s) {
      var side = s[1];
      h += '<div class="ic-materials-when ic-materials-when--' + s[0] + '"><h4 class="ic-h4">Choose ' + esc(side.f.label) + ' when…</h4><p>' + esc(side.when) + '</p>';
      if (side.f.t) h += '<p class="ic-small">Typical range across compounds reviewed: ' + esc(tRange(side.f.t, 'C')) + ' (' + esc(tRange(side.f.t, 'F')) + ').</p>';
      h += '<p class="ic-materials-when__tags"><span class="ic-materials-when__lbl">Wins on</span>' + (side.wins.length ? side.wins.map(function (w) { return '<span class="ic-tag">' + esc(w.label) + '</span>'; }).join('') : '<span class="ic-small">No screened property</span>') + '</p>';
      if (side.weak.length) h += '<p class="ic-materials-when__tags"><span class="ic-materials-when__lbl">Weak spots</span>' + side.weak.map(function (w) { return '<span class="ic-tag ic-materials-tag--weak">' + esc(w) + '</span>'; }).join('') + '</p>';
      h += '</div>';
    });
    h += '</div>';
    return h + cmpFoot(m, A, B, U);
  }
  function cmpFoot(m, A, B, U) {
    var h = '';
    if (m.note) h += '<div class="ic-materials-cmp__note"><p class="ic-eyebrow ic-eyebrow--accent">Selection note</p><p>' + esc(m.note) + '</p></div>';
    h += '<div class="ic-materials-actions ic-materials-cmp__cta">' +
      '<a class="ic-btn ic-btn--primary" href="' + esc(chemUrl(U)) + '">Check your chemicals</a>' +
      '<a class="ic-btn ic-btn--ghost" href="' + esc(rfqUrl(U, 'ENGINEERING_REVIEW', null, 'Material guide: choosing between ' + A.label + ' and ' + B.label + '. Media / temperature / pressure: ')) + '">Ask us to review the choice</a></div>';
    return h;
  }
  /* unrated compare: each family's own guidance lists instead of rating bars */
  function guidance(m, A, B, U) {
    var h = '<div class="ic-materials-cmp__verdict">';
    [['a', A], ['b', B]].forEach(function (s) {
      var f = s[1], list = function (xs) { return '<ul>' + (xs || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>'; };
      h += '<div class="ic-materials-when ic-materials-when--' + s[0] + '"><h4 class="ic-h4">' + esc(f.label) + '</h4>' +
        '<p class="ic-materials-card__lbl is-good">Good starting point for</p>' + list(f.good) +
        '<p class="ic-materials-card__lbl is-warn">Check carefully</p>' + list(f.check);
      if (f.t) h += '<p class="ic-small">Typical range across compounds reviewed: ' + esc(tRange(f.t, 'C')) + ' (' + esc(tRange(f.t, 'F')) + ').</p>';
      h += '</div>';
    });
    return h + '</div>' + cmpFoot(m, A, B, U);
  }

  var api = { pairModel: pairModel, renderCompare: renderCompare, toF: toF, toC: toC, tRange: tRange, LEVEL: LEVEL };
  g.OXXIC_MATERIALS = api;
  if (typeof document === 'undefined') return;

  /* ================= browser ================= */
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function link(href, cls, text) { var a = el('a', cls, text); a.href = href; return a; }

  function urlsFrom(root) {
    return { col: root.getAttribute('data-col-url') || '/collections', finder: root.getAttribute('data-finder-url'), rfq: root.getAttribute('data-rfq-url'), chem: root.getAttribute('data-chem-url') };
  }

  /* ---------- need selector: highlight families across the page ---------- */
  function initNeeds(root, D, U) {
    var chips = [].slice.call(root.querySelectorAll('[data-mat-need]'));
    var out = root.querySelector('[data-mat-need-out]');
    var F = famMap(D);
    function mark(need) {
      root.querySelectorAll('[data-fam]').forEach(function (n) {
        var k = n.getAttribute('data-fam');
        n.classList.remove('is-rec', 'is-alt', 'is-avoid', 'is-dim');
        if (!need) return;
        if (need.rec.indexOf(k) !== -1) n.classList.add('is-rec');
        else if (need.alt.indexOf(k) !== -1) n.classList.add('is-alt');
        else if (need.avoid.indexOf(k) !== -1) n.classList.add('is-avoid', 'is-dim');
        else n.classList.add('is-dim');
      });
      root.classList.toggle('has-need', !!need);
    }
    function famList(title, keys, cls) {
      if (!keys.length) return null;
      var p = el('p', 'ic-materials-need__fams ' + cls);
      p.appendChild(el('span', 'ic-materials-need__lbl', title));
      keys.forEach(function (k) { var f = F[k]; if (f) p.appendChild(link('#mat-' + k, 'ic-materials-need__fam', f.label)); });
      return p;
    }
    function render(need) {
      out.replaceChildren();
      if (!need) { out.appendChild(el('p', 'ic-small', 'Pick a need to highlight the families that fit across the page.')); return; }
      var box = el('div', 'ic-materials-need__res');
      box.appendChild(el('p', 'ic-materials-need__title', need.label));
      [famList('Start here', need.rec, 'is-rec'), famList('Also consider', need.alt, 'is-alt'), famList('Usually avoid', need.avoid, 'is-avoid')].forEach(function (n) { if (n) box.appendChild(n); });
      box.appendChild(el('p', 'ic-materials-need__text', need.text));
      var chk = el('p', 'ic-materials-need__check');
      chk.appendChild(el('strong', null, 'Check: '));
      chk.appendChild(document.createTextNode(need.check));
      box.appendChild(chk);
      var acts = el('div', 'ic-materials-actions');
      var first = need.rec.map(function (k) { return F[k]; }).filter(function (f) { return f && f.sold; })[0];
      if (need.k === 'food') {
        acts.appendChild(link(rfqUrl(U, 'CUSTOM', F.epdm, 'Material guide: food or drinking-water contact. Please quote a compound with compliance documentation. Market / media: '), 'ic-btn ic-btn--primary ic-btn--sm', 'Request a documented compound'));
      } else if (first) {
        acts.appendChild(link(finderUrl(U, first, need.k === 'pressure' ? '&hardness=90' : ''), 'ic-btn ic-btn--primary ic-btn--sm', 'Find a size in ' + first.label + (need.k === 'pressure' ? ' 90A' : '')));
        acts.appendChild(link(shopUrl(U, first), 'ic-btn ic-btn--ghost ic-btn--sm', 'Shop ' + first.label));
      }
      if (need.k === 'pressure') acts.appendChild(link(U.groove, 'ic-btn ic-btn--ghost ic-btn--sm', 'Check the gland'));
      if (first) acts.appendChild(link('/pages/bulk-quote?view=engineer-pro&material=' + encodeURIComponent(first.finder) + (need.k === 'pressure' ? '&hardness=90' : '') + '&source=' + SRC, 'ic-btn ic-btn--ghost ic-btn--sm', 'Engineer Pro review'));
      acts.appendChild(link(chemUrl(U), 'ic-link', 'Chemical check'));
      box.appendChild(acts);
      out.appendChild(box);
    }
    function select(k) {
      var need = null;
      chips.forEach(function (c) { var on = c.getAttribute('data-mat-need') === k; c.setAttribute('aria-pressed', String(on)); });
      D.needs.forEach(function (n) { if (n.k === k) need = n; });
      mark(need); render(need);
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { select(c.getAttribute('aria-pressed') === 'true' ? null : c.getAttribute('data-mat-need')); });
    });
    var reset = root.querySelector('[data-mat-need-reset]');
    if (reset) reset.addEventListener('click', function () { select(null); });
  }

  /* ---------- temperature chart: unit toggle, tooltip, temperature check ---------- */
  function initChart(root) {
    var chart = root.querySelector('[data-mat-chart]');
    if (!chart) return;
    var plot = chart.querySelector('.ic-materials-chart__plot');
    var dmin = +chart.getAttribute('data-dmin'), dmax = +chart.getAttribute('data-dmax');
    var rows = [].slice.call(chart.querySelectorAll('.ic-materials-trow'));
    var tip = chart.querySelector('[data-mat-tip]');
    var input = chart.querySelector('[data-mat-tcheck]');
    var out = chart.querySelector('[data-mat-tcheck-out]');
    var unitLbl = chart.querySelector('[data-mat-unit-label]');
    var unit = 'C';

    function num(r, k) { var v = r.getAttribute('data-' + k); return v === null || v === '' ? null : +v; }
    function fmt(c) { return unit === 'F' ? sn(toF(c)) + ' °F' : sn(Math.round(c)) + ' °C'; }
    function pair(lo, hi) { return unit === 'F' ? sn(toF(lo)) + ' to ' + sn(toF(hi)) + ' °F' : sn(lo) + ' to ' + sn(hi) + ' °C'; }

    function check() {
      var raw = input.value.trim().replace(',', '.').replace(/[−–]/g, '-');
      rows.forEach(function (r) { r.removeAttribute('data-state'); });
      if (raw === '' || isNaN(+raw)) { chart.classList.remove('has-mark'); out.textContent = ''; return; }
      var c = unit === 'F' ? toC(+raw) : +raw;
      var pos = Math.max(0, Math.min(100, (c - dmin) / (dmax - dmin) * 100));
      chart.style.setProperty('--mk', pos.toFixed(2) + '%');
      chart.classList.add('has-mark');
      var ok = [], some = [], no = [];
      rows.forEach(function (r) {
        var name = r.getAttribute('data-label');
        var mn = num(r, 'min'), mx = num(r, 'max'), lo = num(r, 'lo'), hi = num(r, 'hi');
        if (mn === null) { r.setAttribute('data-state', 'na'); return; }
        if (c >= mn && c <= mx) { r.setAttribute('data-state', 'ok'); ok.push(name); }
        else if (c >= lo && c <= hi) { r.setAttribute('data-state', 'some'); some.push(name); }
        else { r.setAttribute('data-state', 'out'); no.push(name); }
      });
      var t = 'At ' + fmt(c) + ': ';
      t += ok.length ? 'typical range covers ' + ok.join(', ') + '. ' : 'no typical range covers it. ';
      if (some.length) t += 'Only wider-range grades of ' + some.join(', ') + '. ';
      if (no.length) t += 'Outside: ' + no.join(', ') + '.';
      out.textContent = t;
    }

    chart.querySelectorAll('input[name="IcMatUnit"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var prev = unit; unit = r.value;
        chart.classList.toggle('is-f', unit === 'F');
        if (unitLbl) unitLbl.textContent = unit === 'F' ? '°F' : '°C';
        if (input.value.trim() !== '' && !isNaN(+input.value) && prev !== unit) {
          var v = +input.value; input.value = String(Math.round(unit === 'F' ? v * 9 / 5 + 32 : (v - 32) * 5 / 9));
        }
        check();
      });
    });
    input.addEventListener('input', check);

    function show(r) {
      var mn = num(r, 'min');
      tip.replaceChildren();
      tip.appendChild(el('strong', null, mn === null ? 'Range confirmed per compound' : pair(mn, num(r, 'max'))));
      tip.appendChild(el('span', null, r.getAttribute('data-label') + ' · ' + r.getAttribute('data-name')));
      if (mn !== null) {
        if (num(r, 'lo') !== mn || num(r, 'hi') !== num(r, 'max')) tip.appendChild(el('span', null, 'Wider-range grades: ' + pair(num(r, 'lo'), num(r, 'hi'))));
        tip.appendChild(el('span', null, r.getAttribute('data-n') + ' compound records with a stated range'));
      } else tip.appendChild(el('span', null, 'Too few records to publish a typical range'));
      var track = r.querySelector('.ic-materials-trow__track') || r;
      var box = plot.getBoundingClientRect(), tb = track.getBoundingClientRect();
      tip.hidden = false;
      var left = tb.left - box.left + tb.width / 2 - tip.offsetWidth / 2;
      left = Math.max(0, Math.min(box.width - tip.offsetWidth, left));
      tip.style.left = left + 'px';
      tip.style.top = (tb.top - box.top - tip.offsetHeight - 8) + 'px';
    }
    function hide() { tip.hidden = true; }
    rows.forEach(function (r) {
      r.addEventListener('pointerenter', function () { show(r); });
      r.addEventListener('pointerleave', hide);
      r.addEventListener('focus', function () { show(r); });
      r.addEventListener('blur', hide);
      var t = r.querySelector('.ic-materials-trow__track');
      if (t) t.addEventListener('pointerenter', function () { show(r); });
    });
    chart.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  /* ---------- property matrix: sort + scope ---------- */
  function initMatrix(root) {
    var mx = root.querySelector('[data-mat-matrix]');
    if (!mx) return;
    var tbody = mx.querySelector('tbody');
    var rows = [].slice.call(tbody.rows);
    var sort = mx.querySelector('[data-mat-sort]');
    var wrap = mx.querySelector('.ic-materials-mx__wrap');
    var status = mx.querySelector('[data-mat-mx-status]');
    // Fill the hidden text for the cost cells (the visible cost scale is decorative $ characters).
    rows.forEach(function (r) {
      var cell = r.querySelector('td[data-r="c"]');
      if (cell) {
        var span = cell.querySelector('.ic-sr');
        if (span) span.textContent = cell.getAttribute('data-v') + ' of 5';
      }
    });
    function apply() {
      var k = sort.value;
      var list = rows.slice();
      if (k) {
        list.sort(function (a, b) {
          var va = +a.getAttribute('data-r-' + k), vb = +b.getAttribute('data-r-' + k);
          var d = k === 'cost' ? va - vb : vb - va;
          return d || (+a.getAttribute('data-i') - +b.getAttribute('data-i'));
        });
      } else list.sort(function (a, b) { return +a.getAttribute('data-i') - +b.getAttribute('data-i'); });
      list.forEach(function (r) { tbody.appendChild(r); });
      mx.querySelectorAll('[data-col]').forEach(function (c) { c.classList.toggle('is-sorted', !!k && c.getAttribute('data-col') === k); });
      var th = k && mx.querySelector('th[data-col="' + k + '"]');
      if (th && wrap.scrollWidth > wrap.clientWidth) {
        var first = mx.querySelector('thead th');
        wrap.scrollLeft = Math.max(0, th.offsetLeft - first.offsetWidth - 8);
      }
      var visible = list.filter(function (r) { return !r.hidden; });
      status.textContent = k ? 'Sorted by ' + sort.options[sort.selectedIndex].text.toLowerCase() + '. First: ' + visible.slice(0, 3).map(function (r) { return r.getAttribute('data-label'); }).join(', ') + '.' : 'Family order.';
    }
    sort.addEventListener('change', apply);
    mx.querySelectorAll('input[name="IcMatScope"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var sold = r.checked && r.value === 'sold';
        rows.forEach(function (row) { row.hidden = sold && row.getAttribute('data-sold') !== '1'; });
        apply();
      });
    });
  }

  /* ---------- compare A vs B (shareable ?compare=a-b) ---------- */
  function initCompare(root, D, U) {
    var box = root.querySelector('[data-mat-compare]');
    if (!box) return;
    var sa = box.querySelector('[data-mat-cmp-a]'), sb = box.querySelector('[data-mat-cmp-b]');
    var out = box.querySelector('[data-mat-cmp-out]');
    var status = box.querySelector('[data-mat-cmp-status]');
    var F = famMap(D);
    function update(push) {
      if (sa.value === sb.value) {
        var alt = D.fam.filter(function (f) { return f.k !== sa.value; })[0];
        sb.value = alt.k;
      }
      var m = pairModel(D, sa.value, sb.value);
      if (!m) return;
      out.innerHTML = renderCompare(D, m, U);
      status.textContent = 'Comparing ' + F[sa.value].label + ' and ' + F[sb.value].label + '.';
      if (push) {
        var u = new URL(window.location.href);
        u.searchParams.set('compare', m.key);
        window.history.replaceState(null, '', u.toString());
      }
    }
    sa.addEventListener('change', function () { update(true); });
    sb.addEventListener('change', function () { update(true); });
    box.querySelector('[data-mat-cmp-swap]').addEventListener('click', function () { var t = sa.value; sa.value = sb.value; sb.value = t; update(true); });
    var copy = box.querySelector('[data-mat-cmp-copy]');
    copy.addEventListener('click', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('compare', sa.value + '-' + sb.value);
      u.hash = 'compare';
      var text = u.toString();
      var done = function () { status.textContent = 'Link copied: ' + text; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { status.textContent = text; });
      else status.textContent = text;
    });
    var q = new URLSearchParams(window.location.search).get('compare');
    var m = q && q.toLowerCase().match(/^([a-z]+)-([a-z]+)$/);
    if (m && F[m[1]] && F[m[2]] && m[1] !== m[2]) {
      sa.value = m[1]; sb.value = m[2];
      if (m[1] + '-' + m[2] !== box.getAttribute('data-default')) update(false);
      if (!window.location.hash) box.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
  }

  function boot() {
    document.querySelectorAll('[data-mat-root]').forEach(function (root) {
      if (root.getAttribute('data-mat-ready')) return;
      root.setAttribute('data-mat-ready', '1');
      var U = urlsFrom(root);
      U.groove = root.getAttribute('data-groove-url');
      initChart(root);
      initMatrix(root);
      var load = window.OXXIC && window.OXXIC.loadJSON ? window.OXXIC.loadJSON(root.getAttribute('data-src'))
        : fetch(root.getAttribute('data-src'), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      load.then(function (D) {
        initNeeds(root, D, U);
        initCompare(root, D, U);
        root.classList.add('is-live');
      }).catch(function () {
        root.querySelectorAll('[data-mat-need]').forEach(function (c) { c.disabled = true; });
      });
    });
  }
  if (window.OXXIC) boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : globalThis);
